/* eslint-disable */
/* eslint-enable no-undef */
import $ from 'jquery';
import _ from 'underscore';

var jQuery = $;
$.advertiser = $.advertiser || {};

$.advertiser.loadingPanel = {
    _i: 1,
    show: function () { $.advertiser.loadingPanel._i++; },
    hide: function () { $.advertiser.loadingPanel._i--; }
};

// Default beforeAjax handler that will be called by jquery.unobtrusive-ajax.js on before ajax event. jquery.unobtrusive-ajax.js only has effect on forms or links that declared on the server view using Ajax.BeginForm or Ajax.ActionLink.
$.advertiser.beforeAjax = function () {
    $.advertiser.clearErrorSummary();
    $.advertiser.showLoadingPanel();
};

// Default on ajax error handler that will be called by jquery.unobtrusive-ajax.js on before ajax event. jquery.unobtrusive-ajax.js only has effect on forms or links that declared on the server view using Ajax.BeginForm or Ajax.ActionLink.
$.advertiser.ajaxError = function (hideLoadingPanel) {
    hideLoadingPanel = hideLoadingPanel == undefined ? true : hideLoadingPanel;
    if (hideLoadingPanel) {
        $.advertiser.hideLoadingPanel();
    }
    var errorMessage = $('#internalErrorMsg').val();
    errorMessage = errorMessage ? errorMessage : 'Internal error.';
    $.advertiser.clearErrorSummary();
    $.advertiser.appendErrorSummary(errorMessage);
};
